<app-modal [header]="'Editar os Dados da Ocorrência'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="cancelModal()">
  <app-form-error [message]="apiErrors.get('eventImage')"></app-form-error>
  <app-file-upload #fileUploadComponent (onFileUpdate)="onFileUpdate($event)"
                   [fileType]="'image/jpeg, image/jpg, image/png'"></app-file-upload>
  @if (redactedPreview) {
    <figure class="mt-4">
      <figcaption class="mb-2 text-sm font-semibold text-neutral-900">Imagem com dados ocultos</figcaption>
      <img [src]="redactedPreview" alt="Imagem com as partes sensíveis desfocadas"
           class="max-h-64 w-full rounded-xl border border-neutral-200 object-contain">
    </figure>
  }
  <header class="mt-4 text-sm text-center text-gray-500">
    <p class="">Formatos permitidos: PNG, JPG, JPEG. Tamanho máximo de 3Mb.</p>
    <p class="text-orange-500">* Por favor certifique-se de que a imagem oculta quaisquer dados sensíveis.</p>
  </header>
  @if (eventImage) {
    <div class="mt-4 flex flex-col items-center gap-2">
      <app-custom-button label="Ocultar partes sensíveis" size="sm" (pressed)="openRedact()"></app-custom-button>
    </div>
  }
  <app-image-redact [file]="redactFile" [open]="redactOpen" (saved)="onImageRedacted($event)" (closed)="onRedactClosed()"></app-image-redact>

  <div class="mt-10 w-full flex justify-center">
    <app-ae-button variant="primary" icon="pi pi-save" type="button" label="Alterar Imagem" [disabled]="eventImage == null"
              (buttonClick)="onApiEditImage()"
              size="sm" styleClass="text-xs mx-auto"></app-ae-button>
  </div>
</app-modal>

